import LoadingAppType from "@/store/redux/types/LoadingAppType";

export const loadingAppSuccess = () => ({
  type: LoadingAppType.LOADING_APP_SUCCESS,
});
